import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:8008/api";
  }
  return "/api";
};

export const explorerPath = (sport, rest) =>
  sport === "mlb" ? `/queryBuilder/${rest}` : `/${sport}/queryBuilder/${rest}`;

export const queryBuilderApi = createApi({
  reducerPath: "queryBuilderApi",
  baseQuery: fetchBaseQuery({
    baseUrl: getApiBaseUrl(),
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("Cache-Control", "no-cache");
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
    responseHandler: async (response) => {
      const data = await response.json();
      if (response.status === 403 && data.code === "ADMIN_REQUIRED") {
        window.location.href = "/app";
      }
      return data;
    },
  }),
  endpoints: (builder) => ({
    executeExplorerQuery: builder.query({
      query: ({ sport, ...body }) => ({
        url: explorerPath(sport, "query"),
        method: "POST",
        body,
      }),
      transformResponse: (response) => {
        if (response.results && Array.isArray(response.results)) {
          return {
            ...response,
            results: response.results.map((player) => ({
              ...player,
              bio: player.bio || player.bioData,
              bioData: player.bioData,
            })),
          };
        }
        return response;
      },
    }),

    previewExplorerCount: builder.query({
      query: ({ sport, ...body }) => ({
        url: explorerPath(sport, "count"),
        method: "POST",
        body,
      }),
    }),

    getExplorerTeams: builder.query({
      query: (sport) => explorerPath(sport, "available-teams"),
    }),
  }),
});

export const {
  useExecuteExplorerQueryQuery,
  usePreviewExplorerCountQuery,
  useGetExplorerTeamsQuery,
} = queryBuilderApi;
